import template from './ongCard.html';
import controller from './ongCard.controller';
import './ongCard.scss';

let ongCardComponent = {
  restrict: 'E',
  bindings: {
    ong: '<',
    onCancel: '&',
    onCreate: '&',
    onEdit: '&'
  },
  template,
  controller,
};

export default ongCardComponent;



// WEBPACK FOOTER //
// ./client/app/solidarity.module/features/mySolidarity/ongsList/ongCard/ongCard.component.js